import React, {forwardRef, useContext, useEffect, useRef, useState} from 'react';
import _axios from '../../../httpService';
import Loader from "../../Loader";
import ChartShow from "./ChartShow";
import FilterReport from "./FilterReport";
import commaSeparator from "../../../utils/CommaSeparator";
import ReactToPrint, {PrintContextConsumer} from "react-to-print";
import tableCalc from "../../../utils/tableCalc";
import DynaTable from "../../MyTable/NewDynaTable";
import {SetPrintDataContext} from "../../../Pages";
import {useNavigate} from "react-router-dom";
import utilsFunction from "../../../utils/utilsFunction";
import {exportXLSXFile} from "../../../utils/exportCSVFile";

const ComponentToPrint = forwardRef((props, ref) => {

  return <div style={{minHeight: '40vh'}} ref={ref}>
    <ChartShow
      type={props.type}
      title={props.title}
      options={props.options}
      data={props.data}
      sum={props.sum}
    />
  </div>

})

const SingleReport = ({title, id, type, hasDate, sum}) => {

  const setprint = useContext(SetPrintDataContext);
  let navigate = useNavigate();
  const myRef = useRef();
  const [data, setData] = useState({});
  const prefixUrl = localStorage.getItem("apiUrl") + "/userDashboardData/"
  const tableRef = useRef();
  const [dateFilter, setDateFilter] = useState({startDate: "", endDate: ""})
  const [dataFromTable, setDataFromTable] = useState([])

  useEffect(() => {
    setData({})
    _axios.get(prefixUrl + "?request=reportData&reportId=" + id + "&startDate=" + dateFilter.startDate + "&endDate=" + dateFilter.endDate).then(r => {
      const data = {...r.data};
      tableCalc.addSeparatorToSingleColumn(data.column, data.priceFields);
      setData(data);
    });
  }, [dateFilter])

  const submitFilter = (startDate, endDate) => {
    setDateFilter({startDate, endDate});
  };

  const GoPrintPage = () => {
    const sendData = {
      type: "SingleReport",
      data: data,
      currentData: dataFromTable,
      title:title
    };
    setprint(sendData);
    navigate("/factorprint");
  }

  const letGoXLS = () => {

    const format = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    };
    const fileName =
      "گزارشات" + new Date().toLocaleDateString("fa-ir", format);
    const normalizeData = utilsFunction.convertTabulatorDataToJson(data?.column, dataFromTable)
    exportXLSXFile(normalizeData, fileName, "")

  }

  try {
    return (
      <>
        {hasDate &&
          <FilterReport
            onSubmit={submitFilter}
            setDateFilter={setDateFilter}
          />
        }
        {Object.keys(data).length > 0 ?
          type === "table" ?
            <>
              <div className={"text-center border border-black on-top-print"}>
                {title} {!isNaN(sum) && "| جمع کل:" + commaSeparator(sum)}

                <button onClick={GoPrintPage} className="print-btn">
                  <span className="printer-wrapper">
                    <span className="printer-container">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 92 75">
                        <path
                          strokeWidth="5"
                          stroke="black"
                          d="M12 37.5H80C85.2467 37.5 89.5 41.7533 89.5 47V69C89.5 70.933 87.933 72.5 86 72.5H6C4.067 72.5 2.5 70.933 2.5 69V47C2.5 41.7533 6.75329 37.5 12 37.5Z"
                        ></path>
                        <mask fill="white" id="path-2-inside-1_30_7">
                          <path
                            d="M12 12C12 5.37258 17.3726 0 24 0H57C70.2548 0 81 10.7452 81 24V29H12V12Z"
                          ></path>
                        </mask>
                        <path
                          mask="url(#path-2-inside-1_30_7)"
                          fill="black"
                          d="M7 12C7 2.61116 14.6112 -5 24 -5H57C73.0163 -5 86 7.98374 86 24H76C76 13.5066 67.4934 5 57 5H24C20.134 5 17 8.13401 17 12H7ZM81 29H12H81ZM7 29V12C7 2.61116 14.6112 -5 24 -5V5C20.134 5 17 8.13401 17 12V29H7ZM57 -5C73.0163 -5 86 7.98374 86 24V29H76V24C76 13.5066 67.4934 5 57 5V-5Z"
                        ></path>
                        <circle fill="black" r="3" cy="49" cx="78"></circle>
                      </svg>
                    </span>
                    <span className="printer-page-wrapper">
                      <span className="printer-page"></span>
                    </span>
                  </span>
                </button>

                <button className="print-btn" onClick={letGoXLS}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10 2h5c5 0 7 2 7 7v6M2 15c0 5 2 7 7 7M2 10v5.5M2 10h4c3 0 4-1 4-4V2l-8 8z"
                    ></path>
                    <path
                      fill="#000"
                      fillRule="evenodd"
                      d="M18.071 15c.434 0 .786.348.786.778v4.666h2.357c.434 0 .786.349.786.778 0 .43-.352.778-.786.778h-3.143a.782.782 0 01-.785-.778v-5.444c0-.43.351-.778.785-.778zm-5.646.326a.79.79 0 00-1.096-.181.773.773 0 00-.183 1.085l1.638 2.27-1.638 2.27a.773.773 0 00.183 1.085.79.79 0 001.096-.18l1.325-1.837 1.325 1.836a.79.79 0 001.096.181.773.773 0 00.183-1.085l-1.638-2.27 1.638-2.27a.773.773 0 00-.183-1.085.79.79 0 00-1.096.18l-1.325 1.837-1.325-1.836z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
              </div>

              <DynaTable
                ref={tableRef}
                column={data.column}
                data={data.data}
                priceFields={data.priceFields}
                className={"solid-table"}
                hasHeaderFilter={true}
                hasOperation={false}
                hasCheckBox={false}
                hasPagination={true}
                rowInPage={12} setDataFromTable={setDataFromTable}/>
            </>
            :
            <>
              <div className={"text-center border border-black on-top-print"}>
                {title} {!isNaN(sum) && "| جمع کل:" + commaSeparator(sum)}

                <ReactToPrint content={() => myRef.current}>
                  <PrintContextConsumer>
                    {({handlePrint}) => (
                      // <Button onClick={handlePrint}>
                      <button onClick={handlePrint} className="print-btn">
                  <span className="printer-wrapper">
                    <span className="printer-container">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 92 75">
                        <path
                          strokeWidth="5"
                          stroke="black"
                          d="M12 37.5H80C85.2467 37.5 89.5 41.7533 89.5 47V69C89.5 70.933 87.933 72.5 86 72.5H6C4.067 72.5 2.5 70.933 2.5 69V47C2.5 41.7533 6.75329 37.5 12 37.5Z"
                        ></path>
                        <mask fill="white" id="path-2-inside-1_30_7">
                          <path
                            d="M12 12C12 5.37258 17.3726 0 24 0H57C70.2548 0 81 10.7452 81 24V29H12V12Z"
                          ></path>
                        </mask>
                        <path
                          mask="url(#path-2-inside-1_30_7)"
                          fill="black"
                          d="M7 12C7 2.61116 14.6112 -5 24 -5H57C73.0163 -5 86 7.98374 86 24H76C76 13.5066 67.4934 5 57 5H24C20.134 5 17 8.13401 17 12H7ZM81 29H12H81ZM7 29V12C7 2.61116 14.6112 -5 24 -5V5C20.134 5 17 8.13401 17 12V29H7ZM57 -5C73.0163 -5 86 7.98374 86 24V29H76V24C76 13.5066 67.4934 5 57 5V-5Z"
                        ></path>
                        <circle fill="black" r="3" cy="49" cx="78"></circle>
                      </svg>
                    </span>
                    <span className="printer-page-wrapper">
                      <span className="printer-page"></span>
                    </span>
                  </span>
                      </button>
                      // </Button>
                    )}
                  </PrintContextConsumer>
                </ReactToPrint>
              </div>
              <ComponentToPrint
                ref={myRef}
                type={data.type}
                title={title}
                options={data.options}
                data={data.data}
                sum={sum}
              />

            </>
          : <Loader/>
        }
      </>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default SingleReport;
